import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { BreadcrumbAboutIsn, BannerAbout, RightMenu, WhyChooseContent, MainServicesContent } from '../../common';
import { getLanguage, getQueryString } from 'utils/params';
import { getCategories, getServices, getWhyChooseUs } from '../../aboutIsn.api';

const WhyChooseComponent = () => {
  const { t } = useTranslation();
  const language = getLanguage(useLocation());
  const [services, setServices] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [banner, setBanner] = useState({});

  const breadCrumb = [
    { title: t('about_isn.home'), url: '/' },
    { title: t('about_isn.about_us'), url: '/about-us' },
    { title: t('about_isn.isn_group_page.group_companies.lbl_name') },
  ];

  useEffect(() => {
    getServices(getQueryString({ language })).then(res => {
      if(res?.data){
        setServices(res?.data);
      }
    });
    getWhyChooseUs(getQueryString({ language })).then(res => {
      if(res?.data) {
        setReasons(res?.data)
      }
    })
    getCategories(getQueryString({language})).then(res => {
      if(res?.data){
        let banner = res?.data.filter(el => {return el.id === 2});
        if(banner){
          setBanner({
            img: `${process.env.REACT_APP_ISN_IMAGE_URL}${banner[0].imageUrl}`, 
            title: t('about_isn.isn_group_page.why_choose_us.lbl_why_choose_us')
          });
        }
      }
    })
    // window.scrollTo(0, 0);
    window.scrollTo({top: 0, behavior: 'smooth'});
    //eslint-disable-next-line
  }, [language]);

  return (
    <>
      <BreadcrumbAboutIsn breadCrumb={breadCrumb} />
      <section className="group-company">
        <BannerAbout banner={banner} />
        <div id="position-scroll"></div>
        <div className="container mt-4">
          <div className="row">
            <div className="col-12 col-md-9">
              <MainServicesContent data={services} />
            </div>
            <div className="col-12 col-md-3 d-xs-none d-sm-none d-md-block" style={{marginTop: 58}}>
              <RightMenu />
            </div>
            <div className="col-12 mt-4">
              <div className="mt-4 main-services-title jp-bold-600 text-uppercase">{t('about_isn.isn_group_page.why_choose_us.lbl_why_choose_us')}</div>
              <WhyChooseContent data={reasons}/>
            </div>
            <div className="col-12 d-none d-sm-block d-md-none">
              <RightMenu />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WhyChooseComponent);
